import { Component } from '@angular/core';
import { ProductType } from 'src/app/enum/product-type';

@Component({
  selector: 'app-traditional-drug',
  templateUrl: './traditional-drug.component.html',
  styleUrls: ['./traditional-drug.component.css'],
})

export class TraditionalDrugComponent {
  public productType:ProductType=ProductType.TraditionalDrug;
}
